import React, { Component } from "react";
import MajorBrow from "../MajorBrow";
import MajorItem from "../MajorItem";
class MajorBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { item } = this.props;
    return (
      <div>
        <MajorBrow
          majorTypeCode={item.majorType.majorTypeCode}
          majorType={item.majorType.majorType}
        ></MajorBrow>
        {item.majors.map((m, index) => {
          return (
            <MajorItem
              key={index}
              majorCode={m.majorCode}
              marjorName={m.majorName}
              level={item.level}
              id={m.id}
            ></MajorItem>
          );
        })}
      </div>
    );
  }
}

export default MajorBox;



// WEBPACK FOOTER //
// ./src/containers/Major/components/MajorBox/index.js